import FlagAllowanceSpec from "./FlagAllowanceSpec";
export default FlagAllowanceSpec;
